import {MolecularGraph} from "../graph/MolecularGraph";
import {Feature, Features} from "../feature";
import {extractorUtil} from "../util/extractorUtil";

export const protonatedFilter = {
    filterInPlace: (features: Feature[], graph: MolecularGraph) => {
        // A protonated atom is an atom that has a +1 charge and is connected to a hydrogen
        const protonatedAtoms = graph.atoms.filter(a => {
            return a.charge === 1 && extractorUtil.getSingleBondsToH(a, graph).length > 0
        })

        // Any feature that contains protonated atoms has the ".protonated" tag added to it.
        features.forEach(feature => {
            if(feature.atoms.some(atom => protonatedAtoms.includes(atom))) {
                feature.name += "." + Features.protonated
            }
        })

        return features;
    }
}
